module.exports = __webpack_public_path__ + "img/top-up-bottom.55a536e.png";